/**
 * Ensures the str is a valid GUID
 * returns str if it's valid otherwise returns empty string
 * @param str string value
 */
export function validateGuid(str: string): string {
  const validRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if (validRegex.test(str)) {
    return str;
  } else return "";
}
